// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","customThumb":"scrollbar_customThumb__xyKLI"};